export default {
  name: 'form-rules',
  translationKey: 'form-rules-module',
  routePrefix: 'form-rules',
  routeNamePrefix: 'admin.form-rules',
  directRoutesAvailable: false,
}
